import { useState } from "react";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { ClosingChecklistListTypeEnum } from "../../../_common/enum/closingChecklistListType.enum";
import { TicketClosingChecklistListClient } from "./ticket-closingChecklistListClient";

export function TicketClosingChecklistClientPanel(params: { paymentDate?: string, invoiceNumber?: string }) { 

    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            <StandardPanel
                title="Closing Checklist Client"
                loading={isLoading}>

                <TicketClosingChecklistListClient paymentDate={params.paymentDate} invoiceNumber={params.invoiceNumber} closingChecklistListTypeId={ClosingChecklistListTypeEnum.Client} />
            </StandardPanel>

        </>
    );

}
